import { ActionContext } from 'vuex';
import { AppConfig, NOTIFICATION_TYPES, generateNotificationItem } from "@/models/AppConfig"
import { AppState } from "@/models/TechnicianAppState"
import axios, { AxiosError, AxiosResponse } from 'axios';
import config from '@/config';
import { STATE_MODULES } from '@/store/state-modules';
import { ConfigMutations } from '../config/mutations';
import { LeadsMutations } from './mutations';
import { LeadsState } from '@/models/LeadsState';
import { leadsConstants } from '@puls/puls-common-constants';
import leadsUtils from '@/utils/leads';
import utils from '@/utils/utils';
import { TechnicianMutations } from '../technician/mutations';

export const LeadsActions = {
	INIT_LEAD_PLANS: 'INIT_LEAD_PLANS',
	CALCULATE_DYNAMIC_PLAN_PRICE: 'CALCULATE_DYNAMIC_PLAN_PRICE',
	SET_PAYMENT_DATA: 'SET_PAYMENT_DATA'
}

export default { 
	async [LeadsActions.INIT_LEAD_PLANS] (context: ActionContext<AppConfig, AppState>) { 
		try { 	
			const { zipcode, market_id, address, service_areas } = context.rootState.technician;
			if (!zipcode) { 
				const zipcode = await utils.getZipcode(address || "Tel Aviv, Israel");
				if (zipcode) {
					context.commit(`${STATE_MODULES.TECHNICIAN}/${TechnicianMutations.UPDATE_FIELD}`, { key: 'zipcode', value: zipcode }, { root: true });
				}
			}

			const payload: any = {}
			if (market_id) payload.market_id = market_id;
			else { 
				payload.service_area_id = service_areas?.values()?.next()?.value;
			}

			if (!market_id && !payload.service_area_id) throw new Error('Invalid market & service area!');

			const { data } = await axios.post(`${config.api}/portal/leads/plans`, payload);
			if (!data?.is_succeeded || !data?.data) throw new Error("Can't get lead plans");

			const { plans, single_lead } = data.data;

			const plansObj = plans.reduce((acc: any, next: any) => {
				acc[next.id] = leadsUtils.generatePlanItem(next)
				return acc;
			}, {})

			context.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_LEADS_PLANS}`, { ...plansObj, [leadsConstants.CUSTOM_PACK_PLAN_ID]: leadsUtils.generatePlanItem(single_lead) }, { root: true })
		} catch (err: any) { 
			// eslint-disable-next-line
			console.error(err)
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.response?.data?.message || "Something went wrong!" }),
				{ root: true }
			);
		}
	},
	[LeadsActions.CALCULATE_DYNAMIC_PLAN_PRICE] (context: ActionContext<LeadsState, AppState>, payload: number) {
		const { zipcode, market_id, email } = context.rootState.technician;
		if (!zipcode || !market_id) throw new Error('Error calculating price');
		const services = Array(payload).fill({ id: leadsConstants.SINGLE_LEAD_SERVICE_ID })
		context.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_CUSTOM_LEADS_AMOUNT}`, payload, { root: true });
		axios.post(`${config.api}/portal/price/leads-cost`, { 
			services, 
			email,
			market_id,
			zipcode
		}).then((response: AxiosResponse) => {
			const { data } = response;
			if (!data?.totalPrice) throw new Error('Error calculating price');
			context.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_CUSTOM_PLAN}`, { price: data.totalPrice, leads_amount: payload }, { root: true })
		}).catch((err: AxiosError<any>) => {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.response?.data?.message || "Something went wrong!" }),
				{ root: true }
			);
		})
	},
	[LeadsActions.SET_PAYMENT_DATA] (context: ActionContext<LeadsState, AppState>) { 
		const { technician } = context.rootState;
		const selectedPlan = context.getters.SELECTED_PLAN;
		const params = { 
			uuid: context.state.uuid,
			email: technician.email,
			market_id: technician.market_id,
			zipcode: technician.zipcode,
			full_address: technician.address,
			first_name: technician.first_name,
			last_name: technician.last_name,
			phone: technician.phone,
			services: leadsUtils.getServicesForPayment(selectedPlan),
			skills: [270, 271, 269], // list of device ids,
			company_name: "N/A",
			areas: Array.from(technician.service_areas)
		}

		axios.post(`${config.api}/portal/payment/leads-context-object`, params).then(() => { 
		}).catch((err: AxiosError<any>) => {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: err.response?.data?.message || "Something wnet wrong!" }),
				{ root: true }
			)
		})
	}
}
